/** FundingUUPS 合约 ABI（独立文件，不修改 abi.js） */
export const fundingUupsAbi = [
    {
        "inputs":[

        ],
        "stateMutability":"nonpayable",
        "type":"constructor"
    },
    {
        "inputs":[
            {
                "internalType":"address",
                "name":"target",
                "type":"address"
            }
        ],
        "name":"AddressEmptyCode",
        "type":"error"
    },
    {
        "inputs":[
            {
                "internalType":"address",
                "name":"implementation",
                "type":"address"
            }
        ],
        "name":"ERC1967InvalidImplementation",
        "type":"error"
    },
    {
        "inputs":[

        ],
        "name":"ERC1967NonPayable",
        "type":"error"
    },
    {
        "inputs":[

        ],
        "name":"FailedCall",
        "type":"error"
    },
    {
        "inputs":[

        ],
        "name":"InvalidInitialization",
        "type":"error"
    },
    {
        "inputs":[

        ],
        "name":"NotInitializing",
        "type":"error"
    },
    {
        "inputs":[
            {
                "internalType":"address",
                "name":"owner",
                "type":"address"
            }
        ],
        "name":"OwnableInvalidOwner",
        "type":"error"
    },
    {
        "inputs":[
            {
                "internalType":"address",
                "name":"account",
                "type":"address"
            }
        ],
        "name":"OwnableUnauthorizedAccount",
        "type":"error"
    },
    {
        "inputs":[

        ],
        "name":"ReentrancyGuardReentrantCall",
        "type":"error"
    },
    {
        "inputs":[
            {
                "internalType":"address",
                "name":"token",
                "type":"address"
            }
        ],
        "name":"SafeERC20FailedOperation",
        "type":"error"
    },
    {
        "inputs":[

        ],
        "name":"UUPSUnauthorizedCallContext",
        "type":"error"
    },
    {
        "inputs":[
            {
                "internalType":"bytes32",
                "name":"slot",
                "type":"bytes32"
            }
        ],
        "name":"UUPSUnsupportedProxiableUUID",
        "type":"error"
    },
    {
        "anonymous":false,
        "inputs":[
            {
                "indexed":true,
                "internalType":"address",
                "name":"oldAddress",
                "type":"address"
            },
            {
                "indexed":true,
                "internalType":"address",
                "name":"newAddress",
                "type":"address"
            }
        ],
        "name":"FundAddressUpdated",
        "type":"event"
    },
    {
        "anonymous":false,
        "inputs":[
            {
                "indexed":false,
                "internalType":"uint64",
                "name":"version",
                "type":"uint64"
            }
        ],
        "name":"Initialized",
        "type":"event"
    },
    {
        "anonymous":false,
        "inputs":[
            {
                "indexed":true,
                "internalType":"address",
                "name":"previousOwner",
                "type":"address"
            },
            {
                "indexed":true,
                "internalType":"address",
                "name":"newOwner",
                "type":"address"
            }
        ],
        "name":"OwnershipTransferred",
        "type":"event"
    },
    {
        "anonymous":false,
        "inputs":[
            {
                "indexed":true,
                "internalType":"address",
                "name":"proxyAddress",
                "type":"address"
            },
            {
                "indexed":true,
                "internalType":"address",
                "name":"owner",
                "type":"address"
            },
            {
                "indexed":true,
                "internalType":"address",
                "name":"payToken",
                "type":"address"
            },
            {
                "indexed":false,
                "internalType":"uint256",
                "name":"launchAmount",
                "type":"uint256"
            },
            {
                "indexed":false,
                "internalType":"string",
                "name":"tokenUri",
                "type":"string"
            }
        ],
        "name":"ProjectLaunched",
        "type":"event"
    },
    {
        "anonymous":false,
        "inputs":[
            {
                "indexed":true,
                "internalType":"address",
                "name":"previousTech",
                "type":"address"
            }
        ],
        "name":"TechAddressRenounced",
        "type":"event"
    },
    {
        "anonymous":false,
        "inputs":[
            {
                "indexed":true,
                "internalType":"address",
                "name":"implementation",
                "type":"address"
            }
        ],
        "name":"Upgraded",
        "type":"event"
    },
    {
        "anonymous":false,
        "inputs":[
            {
                "indexed":true,
                "internalType":"address",
                "name":"proxyAddress",
                "type":"address"
            },
            {
                "indexed":true,
                "internalType":"address",
                "name":"user",
                "type":"address"
            },
            {
                "indexed":true,
                "internalType":"address",
                "name":"payToken",
                "type":"address"
            },
            {
                "indexed":false,
                "internalType":"uint256",
                "name":"quantity",
                "type":"uint256"
            },
            {
                "indexed":false,
                "internalType":"uint256",
                "name":"payAmount",
                "type":"uint256"
            },
            {
                "indexed":false,
                "internalType":"uint256",
                "name":"timestamp",
                "type":"uint256"
            }
        ],
        "name":"crowdFunding",
        "type":"event"
    },
    {
        "anonymous":false,
        "inputs":[
            {
                "indexed":true,
                "internalType":"address",
                "name":"tokenAddress",
                "type":"address"
            },
            {
                "indexed":true,
                "internalType":"bool",
                "name":"status",
                "type":"bool"
            }
        ],
        "name":"supportedPayTokenUpdated",
        "type":"event"
    },
    {
        "inputs":[

        ],
        "name":"UPGRADE_INTERFACE_VERSION",
        "outputs":[
            {
                "internalType":"string",
                "name":"",
                "type":"string"
            }
        ],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[

        ],
        "name":"WBNB_ADDRESS",
        "outputs":[
            {
                "internalType":"address",
                "name":"",
                "type":"address"
            }
        ],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"uint256",
                "name":"",
                "type":"uint256"
            }
        ],
        "name":"allCardAddresses",
        "outputs":[
            {
                "internalType":"address",
                "name":"",
                "type":"address"
            }
        ],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"address",
                "name":"cardAddress",
                "type":"address"
            },
            {
                "internalType":"uint256",
                "name":"quantity",
                "type":"uint256"
            }
        ],
        "name":"calculateTotalPrice",
        "outputs":[
            {
                "internalType":"uint256",
                "name":"totalPrice",
                "type":"uint256"
            }
        ],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"address",
                "name":"",
                "type":"address"
            }
        ],
        "name":"cardInfo",
        "outputs":[
            {
                "internalType":"address",
                "name":"cardToken",
                "type":"address"
            },
            {
                "internalType":"address",
                "name":"admin",
                "type":"address"
            },
            {
                "internalType":"address",
                "name":"payToken",
                "type":"address"
            },
            {
                "internalType":"uint256",
                "name":"supply",
                "type":"uint256"
            },
            {
                "internalType":"uint256",
                "name":"collectAmount",
                "type":"uint256"
            },
            {
                "internalType":"uint256",
                "name":"collectGoal",
                "type":"uint256"
            },
            {
                "internalType":"uint256",
                "name":"initPrice",
                "type":"uint256"
            },
            {
                "internalType":"uint256",
                "name":"increment",
                "type":"uint256"
            },
            {
                "internalType":"uint256",
                "name":"currentPrice",
                "type":"uint256"
            },
            {
                "internalType":"uint256",
                "name":"nextTokenId",
                "type":"uint256"
            },
            {
                "internalType":"bool",
                "name":"isFinish",
                "type":"bool"
            },
            {
                "internalType":"string",
                "name":"cardUri",
                "type":"string"
            }
        ],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"address",
                "name":"cardAddress",
                "type":"address"
            },
            {
                "internalType":"address",
                "name":"parent",
                "type":"address"
            },
            {
                "internalType":"uint256",
                "name":"quantity",
                "type":"uint256"
            }
        ],
        "name":"crowdFundingForEth",
        "outputs":[

        ],
        "stateMutability":"payable",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"address",
                "name":"cardAddress",
                "type":"address"
            },
            {
                "internalType":"address",
                "name":"parent",
                "type":"address"
            },
            {
                "internalType":"uint256",
                "name":"quantity",
                "type":"uint256"
            }
        ],
        "name":"crowdFundingForToken",
        "outputs":[

        ],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"uint256",
                "name":"",
                "type":"uint256"
            }
        ],
        "name":"directShare",
        "outputs":[
            {
                "internalType":"address",
                "name":"",
                "type":"address"
            }
        ],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"address",
                "name":"",
                "type":"address"
            }
        ],
        "name":"friendship",
        "outputs":[
            {
                "internalType":"address",
                "name":"",
                "type":"address"
            }
        ],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[

        ],
        "name":"fundAddress",
        "outputs":[
            {
                "internalType":"address",
                "name":"",
                "type":"address"
            }
        ],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[

        ],
        "name":"getAllCards",
        "outputs":[
            {
                "components":[
                    {
                        "internalType":"address",
                        "name":"cardToken",
                        "type":"address"
                    },
                    {
                        "internalType":"address",
                        "name":"admin",
                        "type":"address"
                    },
                    {
                        "internalType":"address",
                        "name":"payToken",
                        "type":"address"
                    },
                    {
                        "internalType":"uint256",
                        "name":"supply",
                        "type":"uint256"
                    },
                    {
                        "internalType":"uint256",
                        "name":"collectAmount",
                        "type":"uint256"
                    },
                    {
                        "internalType":"uint256",
                        "name":"collectGoal",
                        "type":"uint256"
                    },
                    {
                        "internalType":"uint256",
                        "name":"initPrice",
                        "type":"uint256"
                    },
                    {
                        "internalType":"uint256",
                        "name":"increment",
                        "type":"uint256"
                    },
                    {
                        "internalType":"uint256",
                        "name":"currentPrice",
                        "type":"uint256"
                    },
                    {
                        "internalType":"uint256",
                        "name":"nextTokenId",
                        "type":"uint256"
                    },
                    {
                        "internalType":"bool",
                        "name":"isFinish",
                        "type":"bool"
                    },
                    {
                        "internalType":"string",
                        "name":"cardUri",
                        "type":"string"
                    }
                ],
                "internalType":"struct FundingUUPS.CardInfo[]",
                "name":"",
                "type":"tuple[]"
            }
        ],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"address",
                "name":"user",
                "type":"address"
            }
        ],
        "name":"getDirectShare",
        "outputs":[
            {
                "internalType":"address[]",
                "name":"",
                "type":"address[]"
            }
        ],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"address",
                "name":"user",
                "type":"address"
            }
        ],
        "name":"getOrderList",
        "outputs":[
            {
                "components":[
                    {
                        "internalType":"address",
                        "name":"cardToken",
                        "type":"address"
                    },
                    {
                        "internalType":"address",
                        "name":"payToken",
                        "type":"address"
                    },
                    {
                        "internalType":"uint256",
                        "name":"payAmount",
                        "type":"uint256"
                    },
                    {
                        "internalType":"uint256",
                        "name":"cardAmount",
                        "type":"uint256"
                    },
                    {
                        "internalType":"uint256",
                        "name":"timestamp",
                        "type":"uint256"
                    }
                ],
                "internalType":"struct FundingUUPS.OrderInfo[]",
                "name":"",
                "type":"tuple[]"
            }
        ],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"address",
                "name":"user",
                "type":"address"
            }
        ],
        "name":"getUserSubAndRewardData",
        "outputs":[
            {
                "components":[
                    {
                        "internalType":"address",
                        "name":"token",
                        "type":"address"
                    },
                    {
                        "internalType":"uint256",
                        "name":"amount",
                        "type":"uint256"
                    }
                ],
                "internalType":"struct FundingUUPS.TokenAmountView[]",
                "name":"subscriptions",
                "type":"tuple[]"
            },
            {
                "components":[
                    {
                        "internalType":"address",
                        "name":"token",
                        "type":"address"
                    },
                    {
                        "internalType":"uint256",
                        "name":"amount",
                        "type":"uint256"
                    }
                ],
                "internalType":"struct FundingUUPS.TokenAmountView[]",
                "name":"rewards",
                "type":"tuple[]"
            }
        ],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[

        ],
        "name":"initialParent",
        "outputs":[
            {
                "internalType":"address",
                "name":"",
                "type":"address"
            }
        ],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[
            {
                "components":[
                    {
                        "internalType":"address",
                        "name":"initialOwner",
                        "type":"address"
                    },
                    {
                        "internalType":"address",
                        "name":"initialParent",
                        "type":"address"
                    },
                    {
                        "internalType":"address",
                        "name":"techAddress",
                        "type":"address"
                    },
                    {
                        "internalType":"address",
                        "name":"fundAddress",
                        "type":"address"
                    }
                ],
                "internalType":"struct FundingUUPS.InitConfig",
                "name":"config",
                "type":"tuple"
            }
        ],
        "name":"initialize",
        "outputs":[

        ],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"address",
                "name":"payToken",
                "type":"address"
            },
            {
                "internalType":"uint256",
                "name":"initPrice",
                "type":"uint256"
            },
            {
                "internalType":"uint256",
                "name":"increment",
                "type":"uint256"
            },
            {
                "internalType":"uint256",
                "name":"launchAmount",
                "type":"uint256"
            },
            {
                "internalType":"string",
                "name":"tokenUri",
                "type":"string"
            }
        ],
        "name":"launchProject",
        "outputs":[
            {
                "internalType":"address",
                "name":"",
                "type":"address"
            }
        ],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"address",
                "name":"",
                "type":"address"
            },
            {
                "internalType":"uint256",
                "name":"",
                "type":"uint256"
            }
        ],
        "name":"orderInfo",
        "outputs":[
            {
                "internalType":"address",
                "name":"cardToken",
                "type":"address"
            },
            {
                "internalType":"address",
                "name":"payToken",
                "type":"address"
            },
            {
                "internalType":"uint256",
                "name":"payAmount",
                "type":"uint256"
            },
            {
                "internalType":"uint256",
                "name":"cardAmount",
                "type":"uint256"
            },
            {
                "internalType":"uint256",
                "name":"timestamp",
                "type":"uint256"
            }
        ],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[

        ],
        "name":"owner",
        "outputs":[
            {
                "internalType":"address",
                "name":"",
                "type":"address"
            }
        ],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[

        ],
        "name":"proxiableUUID",
        "outputs":[
            {
                "internalType":"bytes32",
                "name":"",
                "type":"bytes32"
            }
        ],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[

        ],
        "name":"renounceOwnership",
        "outputs":[

        ],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[

        ],
        "name":"renounceTechAddress",
        "outputs":[

        ],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"address",
                "name":"_fundAddress",
                "type":"address"
            }
        ],
        "name":"setFundAddress",
        "outputs":[

        ],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"address[]",
                "name":"tokenAddress",
                "type":"address[]"
            },
            {
                "internalType":"bool",
                "name":"enabled",
                "type":"bool"
            }
        ],
        "name":"setSupportedPayTokenBatch",
        "outputs":[

        ],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"address",
                "name":"",
                "type":"address"
            }
        ],
        "name":"supportedPayToken",
        "outputs":[
            {
                "internalType":"bool",
                "name":"",
                "type":"bool"
            }
        ],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[

        ],
        "name":"techAddress",
        "outputs":[
            {
                "internalType":"address",
                "name":"",
                "type":"address"
            }
        ],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"address",
                "name":"newOwner",
                "type":"address"
            }
        ],
        "name":"transferOwnership",
        "outputs":[

        ],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"address",
                "name":"newImplementation",
                "type":"address"
            },
            {
                "internalType":"bytes",
                "name":"data",
                "type":"bytes"
            }
        ],
        "name":"upgradeToAndCall",
        "outputs":[

        ],
        "stateMutability":"payable",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"address",
                "name":"",
                "type":"address"
            },
            {
                "internalType":"uint256",
                "name":"",
                "type":"uint256"
            }
        ],
        "name":"userDirectShare",
        "outputs":[
            {
                "internalType":"address",
                "name":"",
                "type":"address"
            }
        ],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"address",
                "name":"",
                "type":"address"
            }
        ],
        "name":"userFundingAmount",
        "outputs":[
            {
                "internalType":"uint256",
                "name":"",
                "type":"uint256"
            }
        ],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[
            {
                "internalType":"address",
                "name":"",
                "type":"address"
            },
            {
                "internalType":"address",
                "name":"",
                "type":"address"
            }
        ],
        "name":"userTokenStats",
        "outputs":[
            {
                "internalType":"uint256",
                "name":"totalSubscribed",
                "type":"uint256"
            },
            {
                "internalType":"uint256",
                "name":"totalReward",
                "type":"uint256"
            },
            {
                "internalType":"bool",
                "name":"isRecorded",
                "type":"bool"
            }
        ],
        "stateMutability":"view",
        "type":"function"
    }
];

export const erc20MinimalAbi = [
  {
    inputs: [],
    name: "decimals",
    outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "owner", type: "address" },
      { internalType: "address", name: "spender", type: "address" },
    ],
    name: "allowance",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" },
    ],
    name: "approve",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
];
